import { defineStore } from 'pinia';

import { useHotelSelectionStore } from '../../pages/hotelSelection/stores';
import { useActivitySelectionStore } from '../../pages/activitySelection/stores';
import { useFerryListPanelsStore } from '../../pages/ferry/store/ferryListPanelsStore';

import { useRouterStore } from './routerStore';

export const usePageConnectorStore = defineStore('PageConnectorStore', () => {
  const routerStore = useRouterStore();
  const hotelSelectionStore = useHotelSelectionStore();
  const activitySelectionStore = useActivitySelectionStore();
  const ferryListPanelsStore = useFerryListPanelsStore();

  async function openHotelSelectionFilters(
    ingredientIndex: number
  ): Promise<void> {
    await routerStore.navigateToHotelSelection({ ingredientIndex });
    hotelSelectionStore.openFilters('overviewNoAvail');
  }

  async function openActivitySelectionFilters(
    ingredientIndex: number
  ): Promise<void> {
    await routerStore.navigateToActivitySelection({ ingredientIndex });
    activitySelectionStore.toggleFilters();
  }

  async function openFerryListFilters(): Promise<void> {
    await routerStore.navigateToFerryList();
    ferryListPanelsStore.openFiltersPanel();
  }

  return {
    openHotelSelectionFilters,
    openActivitySelectionFilters,
    openFerryListFilters,
  };
});
